import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
  FaPhoneAlt,
} from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { ImLocation2 } from "react-icons/im";
import logo from "../../Assets/Logos/m-logo.svg";
import bg_img from "../../Assets/Images/Footer_bg.png";
import axiosInstance from "../../utils/axios";
import { AiOutlineYoutube } from "react-icons/ai";

const UserFooter = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [services, setServices] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchServices = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/services/all");
      setServices(res.data);
    } catch (error) {
      console.error("Error fetching services in footer:", error.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/products/all");
      setProducts(res.data);
    } catch (error) {
      console.error("Error fetching products in footer:", error.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchServices();
    fetchProducts();
  }, []);
  return (
    <React.Fragment>
      <footer className="bg-[#02081B] text-white">
        <div
          style={{
            backgroundImage: `url(${bg_img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="container mx-auto px-4 md:px-10 py-10"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-16 gap-y-10">
            {/* Company Info */}
            <div>
              <div>
                <img src={logo} alt="Manika Automotive" />
              </div>
              <p className="font-sans font-normal text-[#D9D9D9] text-base leading-6 tracking-[0.5%] align-middle mt-4 mb-6">
                Manika Automotive Service provides a wide range of services,
                including car denting and painting, mechanical work, brake
                repairs, oil changes, and more.
              </p>

              {/* Social Media Icons */}
              <div className="flex space-x-4 mt-4">
                <button
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/hydrotechcleanenergybhubaneswar",
                      "_blank"
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-[#02081B] hover:bg-blue-500 transition duration-300"
                >
                  <FaFacebook size={20} />
                </button>
                <button
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/manika-automotive-service-047459374?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
                      "_blank"
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-[#02081B] hover:bg-blue-700 transition duration-300"
                >
                  <FaLinkedin size={20} />
                </button>
                <button
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/manika_automotive_service?igsh=bHcybWp0bW9ndWg3",
                      "_blank"
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-[#02081B] hover:bg-pink-500 transition duration-300"
                >
                  <FaInstagram size={20} />
                </button>
                <button
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/manika_automotive_service?igsh=bHcybWp0bW9ndWg3",
                      "_blank"
                    )
                  }
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-[#02081B] hover:bg-red-500 transition duration-300"
                >
                  <AiOutlineYoutube size={26} />
                </button>
              </div>
            </div>

            {/* Our Services */}
            <div>
              <h5 className="font-orbitron font-semibold text-[20px] leading-[35px] tracking-[0.5%] align-middle text-[#FFFFFF] mb-2">
                Our Services
              </h5>
              <ul>
                {services.map((service) => (
                  <li key={service}>
                    <Link
                      to={`/our-services/${service._id}`}
                      className="text-[#ffffff] font-montserrat font-medium text-[16px] leading-[40px] tracking-[0.5%] align-middle"
                    >
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Our Products */}
            <div>
              <h5 className="font-orbitron font-semibold text-[20px] leading-[35px] tracking-[0.5%] align-middle text-[#FFFFFF] mb-2">
                Our Products
              </h5>
              <ul>
                {products.map((product) => (
                  <li key={product}>
                    <Link
                      to={`/our-products/${product._id}`}
                      className="text-[#ffffff] font-montserrat font-medium text-[16px] leading-[40px] tracking-[0.5%] align-middle"
                    >
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h5 className="font-orbitron font-semibold text-[20px] leading-[35px] tracking-[0.5%] align-middle text-[#FFFFFF] mb-2">
                Contact Us
              </h5>
              <ul className="space-y-4 mt-2">
                <li className="flex items-start">
                  <FaPhoneAlt
                    className="mt-1 mr-3 flex-shrink-0 text-[#E8471B]"
                    size={20}
                  />
                  <span>7017774127, 7656934714</span>
                </li>
                <li className="flex items-start">
                  <IoMail
                    className="mt-1 mr-3 flex-shrink-0 text-[#E8471B]"
                    size={20}
                  />
                  <span>manikainfo@gmail.com</span>
                </li>
                <li className="flex items-start">
                  <ImLocation2
                    className="mt-1 mr-3 flex-shrink-0 text-[#E8471B]"
                    size={20}
                  />
                  <span>
                    Near Reliance Fresh Signature, Satya Vihar, Rasulgarh,
                    Bhubaneswar, Odisha 751010
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div>
          <hr />
        </div>

        {/* Copyright */}
        <div className="text-[#FFFFFFB2] py-3 px-4 md:px-10">
          <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
            <div className="font-open-sans font-normal text-[12px] leading-[19.5px] tracking-[0%] align-middle text-center md:text-left">
              Copyright © {currentYear} | All Rights Reserved{" "}
              <span className="text-[#E8471B] font-open-sans font-semibold text-[12px] leading-[19.5px] tracking-[0%] align-middle">
                MANIKA AUTOMOTIVE
              </span>
            </div>
            <div className="flex flex-wrap justify-center md:justify-end mt-2 md:mt-0 space-x-4">
              <p className="font-open-sans font-normal text-[12px] leading-[19.5px] tracking-[0%] align-middle text-[#ffffff]">
                Designed & Developed by Web_Bocket
              </p>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default UserFooter;
